import { OverlayModule } from '@angular/cdk/overlay';
import { Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment';
import { MatDividerModule } from '@angular/material/divider';
import { CommonUtils } from '../../utils/common.utils';
import { UserInfo } from '../../model/common.model';
import { IStepOption, TourMatMenuModule, TourService} from 'ngx-ui-tour-md-menu'
import { matTourSteps, stepKeys } from '../../model/matTour.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ERROR_RESPONSE } from '../../model/api.model';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatIconModule, OverlayModule, MatDividerModule, TourMatMenuModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent{ 
public isProfileOpen = false;
public userInfo:UserInfo = {
  userName:'',
  workdayId:''
}
public readonly tourService = inject(TourService);
private readonly dialog = inject(MatDialog)
readonly tourSteps:IStepOption[] = matTourSteps;
public stepKeys = stepKeys
public readonly commonUtils = inject(CommonUtils);
@Input() navbarComponent :any
  toggleMenu() {
    this.navbarComponent.toggleSidenav(); 
  } 
  async ngOnInit(){ 
    this.userInfo = JSON.parse(sessionStorage.getItem('UserInfo') ?? '');
    this.commonUtils.profileDataOnChange.subscribe((res:UserInfo)=>{
      this.userInfo = res
    })
  }
  logout() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: { message: ERROR_RESPONSE['logoutMsg'], header:'Logout' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        sessionStorage.clear();
        sessionStorage.clear();
        globalThis.location.href = environment.logoutUrl;
      }
      this.isProfileOpen = false
    });
  }
  startTour(){
    this.tourService.start();
  }
}
